
<template>
  <div id="app_mobile_header" class="d-flex d-md-none bg-white align-items-center justify-content-between">
    <div id="mobile_aside_menu_toggle_btn" @click="showMenu">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#a0a0a0" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
      </svg>
    </div>
    <div class="mobile-header-logo">
      <router-link to="/"><img :src="currentLogo" alt="paystar" width="100" height="30"></router-link>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <div class="px-2" v-if="admin_hashid" @click="backToAdminPanel">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="#a0a0a0" viewBox="0 -960 960 960" width="24">
          <path d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z"/>
        </svg>
      </div>
      <div class="px-2">
        <dark-mode-button></dark-mode-button>
      </div>
      <div class="px-2">
        <router-link to="/user-news">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#a0a0a0"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z"/></svg>
          <div v-if="new_news_count > 0" id="new_news_badge_mobile" v-text="new_news_count"></div>
        </router-link>
      </div>
      <router-link to="/logout">
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" width="24"
             fill="#a0a0a0" viewBox="0 0 24 24">
          <g>
            <path d="M0,0h24v24H0V0z" fill="none"/>
          </g>
          <g>
            <g>
              <path
                  d="M5,5h6c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h6c0.55,0,1-0.45,1-1v0 c0-0.55-0.45-1-1-1H5V5z"/>
              <path
                  d="M20.65,11.65l-2.79-2.79C17.54,8.54,17,8.76,17,9.21V11h-7c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h7v1.79 c0,0.45,0.54,0.67,0.85,0.35l2.79-2.79C20.84,12.16,20.84,11.84,20.65,11.65z"/>
            </g>
          </g>
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import {mapGetters, mapState} from "vuex";
import DarkModeButton from './dark-mode-button.vue';

export default {
  name: "mobile-header",
  components: {
    DarkModeButton,
  },
  data() {
    return {
      new_news_count: 0,
      admin_hashid: null,
      currentTheme: 'dark'
    };
  },
  computed: {
    currentLogo() {
      return require('@/assets/new/image/logo_new_dark.png');
    },
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapState("news", [
      "newslist",
    ]),
  },
  watch: {
    newslist() {
      this.setNewNewsCount();
    },
  },
  methods: {
    setNewNewsCount() {
      let news_old_count = window.localStorage.getItem('news_old_count');
      let news_new_count = window.localStorage.getItem('news_new_count');

      if (news_old_count == null || news_old_count == undefined) {
        news_old_count = 0;
      } else {
        news_old_count = parseInt(news_old_count);
      }

      if (news_new_count == null || news_new_count == undefined) {
        news_new_count = 0;
      } else {
        news_new_count = parseInt(news_new_count);
      }

      this.new_news_count = news_new_count - news_old_count;
    },
    showMenu() {
      $('#app_mobile_aside').animate({width: 'toggle'}, 100);
    },
    backToAdminPanel() {
      let admin_token = window.localStorage.getItem('Admin_token')

      let param = {
        token: admin_token,
        hashid: this.user.admin_id
      }

      this.$store.dispatch('auth/backToAdminPanel', param)
          .then(
              response => {
                window.localStorage.removeItem('Admin_token')
                window.location.replace(this.$url(''))
              }
          )
    },
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'light';
    },
    setupStorageListener() {
      window.addEventListener('storage', (e) => {
        if (e.key === 'AppUiTheme') {
          this.updateTheme();
        }
      });

      window.addEventListener('themeChanged', () => {
        this.updateTheme();
      });

      this.themeCheckInterval = setInterval(() => {
        const newTheme = window.localStorage.getItem('AppUiTheme') || 'light';
        if (newTheme !== this.currentTheme) {
          this.currentTheme = newTheme;
        }
      }, 100);
    }
  },
  mounted() {
    this.setNewNewsCount();

    this.updateTheme();
    this.setupStorageListener();

    if (this.user.admin_id) {
      this.admin_hashid = this.user.admin_id
    }
  },
  beforeDestroy() {
    if (this.themeCheckInterval) {
      clearInterval(this.themeCheckInterval);
    }
    window.removeEventListener('storage', this.updateTheme);
    window.removeEventListener('themeChanged', this.updateTheme);
  }
}
</script>

<style scoped>
.mobile-header-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#new_news_badge_mobile {
  position: absolute !important;
  bottom: 18px !important;
  z-index: 60 !important;
  background-color: #00c1a4 !important;
  border-radius: 50% !important;
  color: #fff !important;
  text-align: center !important;
  width: 16px !important;
  height: 16px !important;
  opacity: 0.9 !important;
}
</style>
